export const textareaSx = {
    width: "100%",
    p: 2,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "border.default",
    bg: "canvas.default",
    color: "fg.default",
    fontFamily: "inherit",
    fontSize: 1,
    resize: "vertical",
} as const;

export const sectionLabelSx = {
    fontSize: 0,
    fontWeight: "bold",
    color: "fg.muted",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
} as const;
